// component designed to render stacked bar chart with 3 input bar element with their respective colors
// sample data for chart is imported and commented

import React from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";

// sample data for component to work
// import { stackBarChartData } from "../config/index";

export const StackedBarChart = (props) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={props.data} barSize={60}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={props.xAxisDataKey} />
        <YAxis />
        <Tooltip />
        <Legend
          width="100%"
          wrapperStyle={{
            bottom: -40,
            // backgroundColor: "#f5f5f5",
            // border: "1px solid #d5d5d5",
            // borderRadius: 3,
            // lineHeight: "40px",
          }}
          verticalAlign="bottom"
          align="center"
        />
        <Bar dataKey={props.barDataKey1} stackId="a" fill={props.bar1Color}>
          <LabelList dataKey={props.barDataKey1} position="center" />
          <LabelList
            dataKey="Name"
            position="bottom"
            offset="10"
            margin={{ bottom: 20 }}
          />
        </Bar>
        <Bar dataKey={props.barDataKey2} stackId="a" fill={props.bar2Color}>
          <LabelList dataKey={props.barDataKey2} position="center" />
        </Bar>
        <Bar dataKey={props.barDataKey3} stackId="a" fill={props.bar3Color}>
          <LabelList dataKey={props.barDataKey3} position="center" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

StackedBarChart.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  xAxisDataKey: PropTypes.string.isRequired,
  barDataKey1: PropTypes.string.isRequired,
  barDataKey2: PropTypes.string.isRequired,
  barDataKey3: PropTypes.string.isRequired,
  bar1Color: PropTypes.string.isRequired,
  bar2Color: PropTypes.string.isRequired,
  bar3Color: PropTypes.string.isRequired,
};

export default StackedBarChart;
